<template>
    <div class="student-task-list-page">
        <card header-classes="bg-transparent" body-classes="bg-transparent p-0">
            <div slot="header" class="row align-items-center">
                <div class="col-lg-6">
                    <h6 class="text-uppercase ls-1 mb-1">Setting Background</h6>
                </div>
            </div>
            <div class="text-center text-muted">
                <div class="card shadow" :class="type === 'dark' ? 'bg-default': ''">
                    <div class="p-2">
                        <b-row>
                            <b-col lg="1" class="my-1">
                                <b-form-select
                                    id="per-page-select"
                                    v-model="perPage"
                                    :options="pageOptions"
                                    size="sm"
                                ></b-form-select>
                            </b-col>
                            <b-col lg="7" class="my-1">
                            </b-col>
                            <b-col lg="4" class="my-1">
                                <b-input-group size="sm">
                                    <b-form-input
                                    id="filter-input"
                                    v-model="filter"
                                    type="search"
                                    placeholder="Cari"
                                    ></b-form-input>

                                    <b-input-group-append>
                                    <b-button variant="primary" style="border-radius:0px !important;" :disabled="!filter" @click="filter = ''">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-col>
                        </b-row>
                        <b-table
                            :items="backgroundSettingList"
                            :fields="fields"
                            :busy="isBusy"
                            :current-page="currentPage"
                            :per-page="perPage"
                            :filter="filter"
                            :filter-included-fields="filterOn"
                            :sort-by.sync="sortBy"
                            :sort-desc.sync="sortDesc"
                            :sort-direction="sortDirection"
                            responsive="sm"
                            show-empty
                            small
                            @filtered="onFiltered"
                        >
                            <template #table-busy>
                                <div class="text-center text-danger my-2">
                                    <img class="img-loading" src="../../../assets/img/logo-daring.png" alt="Logo"/><br>
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                            </template>
                            <template #cell(page)="row">
                                <div class="list-data text-left">
                                    <label>{{row.item.page}}</label>
                                </div>
                            </template>
                            <template #cell(image_path)="row">
                                <div class="media d-flex justify-content-center">
                                    <a href="javascript:void(0)" class="">
                                        <img alt="" width="700px" :src="row.item.image_path">
                                    </a>
                                </div>
                            </template>
                             <template #cell(actions)="row">
                                <div class="my-2">
                                    <a href="javascript:void(0)" v-b-tooltip.hover title="Ubah" class="icon-clicked p-1" @click="showFormModal(row.item)"><i class="fa fa-edit" aria-hidden="true"></i></a>
                                </div>
                            </template>
                        </b-table>
                        <div class="d-flex justify-content-lg-end justify-content-center py-2">
                            <b-pagination
                                v-model="currentPage"
                                :total-rows="totalRows"
                                :per-page="perPage"
                                align="fill"
                                size="sm"
                                class="my-0"
                            ></b-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </card>
        <b-modal
			ref="background-form-modal"
			class="background-form-modal"
			size="md"
            :title="setTitle"
            @show="resetForm"
            @hidden="resetForm"
			hide-footer
			no-close-on-backdrop
		>
            <background-form
                :id="id"
                :detail="detail"
            ></background-form>
		</b-modal>
    </div>
</template>
<style scoped>
.foto-field{
    height: 50px;
}
</style>
<script>
    import { mapGetters } from 'vuex'
    import { EventBus } from '@/eventBus.js'
    import BackgroundForm from "../../../components/Main/Background/BackgroundForm";

    // import SquareLoader from 'vue-spinner/src/SquareLoader.vue'
    export default {
        props: {
            type: {
                type: String,
                default: null
            },
        },
        components: {
            BackgroundForm
            // SquareLoader
        },
        data() {
            return {
                setTitle: "",
                id: null,
                detail: {},
                isBusy: false,
                showLoader: false,
                fields: [
                    { key: 'page', label: 'Halaman', sortable: true, class: 'text-left' },
                    { key: 'image_path', label: 'Gambar Background', sortable: false, class: 'foto-field'},
                     { key: 'actions', label: 'Aksi', class: 'action-field' }
                ],
                filter_form: {
                    id: null,
                    image_path: null,
                },
                totalRows: 1,
                currentPage: 1,
                perPage: 25,
                pageOptions: [25, 50, 100, 200, 400, 800, 1000],
                sortBy: '',
                sortDesc: false,
                sortDirection: 'asc',
                filter: null,
                filterOn: []
            }
        },
        computed: {
            ...mapGetters({
                user: 'getUser',
                backgroundSettingList: 'getBackgroundSettingList'
            })
        },
        methods: {
            onFiltered(filteredItems) {
                this.totalRows = filteredItems.length
                this.currentPage = 1
            },
            showFormModal(param) {
                if (param) {
                    this.id = param.id
                    this.detail = param
                    this.setTitle = "Edit Gambar Background"
                }
                this.$refs['background-form-modal'].show()
            },
            hideFormModal() {
                this.$refs['background-form-modal'].hide()
                this.resetForm()
            },
            resetForm() {
                EventBus.$emit('resetForm', true)
            },
            async getBackgroundSettingList() {
                this.isBusy = true
                await this.$store.dispatch('getBackgroundSettingList')
					.then(() => {
                        this.isBusy = false
					})
					.catch((err)=> {
                        this.isBusy = false
						this.$swal.fire('Failed', err.response.data.message, 'error')
					})
			},
        },
        mounted() {
            this.totalRows = this.backgroundSettingList.length
        },
        async created() {
            await this.getBackgroundSettingList();
            EventBus.$on('hideFormModal', (val) => {
				if (val) {
					this.hideFormModal()
				}
			})
        }
    }
</script>
<style lang="css" scoped>
.line-with-icon svg {
    /* color: #adb7be; */
    position: absolute;
    left: 0;
    top: 0;
    font-size: 1rem;
}
.line-with-icon {
    position: relative;
    padding: 0 0 0 1.75em;
    margin: 0 0 1em;
}
.user-article a {
    color: black;
}
.class-list > .line-with-icon > a{
    color:#ca062a
}
.user-article a:hover {
    color: #ca062a;
}

.btn-open-answer {
    color: #6c757d
}
.btn-open-answer:hover {
    color: #ca062a;
}
</style>